import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle.min";
import axios from "axios";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import { CartProvider } from "./components/CartContext";
import { ShopCartProvider } from "./components/ShopCartContext";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { HelmetProvider } from "react-helmet-async";

import {
  logoutUser,
  logoutSeller,
  logoutCentre,
  logoutAdmin,
  clearAllSessions,
  showSessionToast,
  notifyAuthChange,
} from "./utils/authSession";

// Global Axios response interceptor for handling expired sessions (401 / 403)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequestUrl = error.config?.url || "";
    const isLoginRoute =
      originalRequestUrl.toLowerCase().includes("login") ||
      originalRequestUrl.toLowerCase().includes("verify-otp") ||
      originalRequestUrl.toLowerCase().includes("send-otp") ||
      originalRequestUrl.toLowerCase().includes("check-user") ||
      originalRequestUrl.toLowerCase().includes("auth");

    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403) &&
      !isLoginRoute
    ) {
      const currentPath = window.location.pathname;

      if (
        currentPath.includes("seller-dashboard") ||
        originalRequestUrl.includes("/seller") ||
        localStorage.getItem("sellerToken")
      ) {
        logoutSeller({ reason: "expired" });
      } else if (
        currentPath.includes("user-dashboard") ||
        currentPath.includes("user-profile") ||
        currentPath.includes("medical-history") ||
        currentPath.includes("booking-report") ||
        currentPath.includes("appointments") ||
        currentPath.includes("requests") ||
        currentPath.includes("orders") ||
        originalRequestUrl.includes("/user") ||
        originalRequestUrl.includes("/buyer")
      ) {
        logoutUser({ reason: "expired" });
      } else if (
        currentPath.includes("centre") ||
        currentPath.includes("doctors") ||
        currentPath.includes("follower") ||
        currentPath.includes("statement") ||
        currentPath.includes("earning") ||
        currentPath.includes("refund")
      ) {
        logoutCentre({ reason: "expired" });
      } else if (currentPath.includes("admin")) {
        logoutAdmin({ reason: "expired" });
      } else {
        clearAllSessions();
        notifyAuthChange();
        showSessionToast("Session expired. Please log in again.");
      }
    }
    return Promise.reject(error);
  }
);

// Redirect only on the first load
if (
  window.location.pathname === "/" &&
  !sessionStorage.getItem("initialRedirectDone")
) {
  sessionStorage.setItem("initialRedirectDone", "true");
  window.location.replace("/shop");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <HelmetProvider>
      <ShopCartProvider>
      <CartProvider>
        <App />
      </CartProvider>
      </ShopCartProvider>
    </HelmetProvider>
  </>,
);

reportWebVitals();
